exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-results .result-header-item{color:#1192af}.search-results .result-header-item:hover{cursor:inherit}.search-results .sortable:hover{cursor:pointer;opacity:.8}.search-results .arrow-img{margin-left:3px;width:13px;height:13px}.search-results td{max-width:175px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/less/searchResults.less
// module id = 1644
// module chunks = 0